import { z } from 'zod';

export const signupSchema = z.object({
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  email: z.union([z.literal(''), z.string().email()]).optional(),
  phone_number: z.string().nonempty(),
  lang: z.string().optional(),
  country: z.string().optional(),
  company_id: z.number().nonnegative(),
  is_marketing_subscriber: z.boolean().optional().default(false),
  offers_phone: z.boolean().optional().default(false),
});

export type SignupSchema = z.infer<typeof signupSchema>;
